import { Link } from 'react-router-dom';
import { sites } from '@/mocks/sites';
import SectionHeading from '@/components/base/SectionHeading';
import { formatDate, sortSites } from '@/utils/siteUtils';

export default function NewSites() {
  const latest = sortSites(sites, 'new').slice(0, 6);

  return (
    <section>
      <SectionHeading
        icon="ri-time-line"
        title="新增网站速递"
        subtitle="最新收录的优质网站，持续更新中"
      />
      <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {latest.map((site) => (
          <Link
            key={site.id}
            to={`/detail/${site.id}`}
            className="group flex items-center gap-3 p-3 transition-colors hover:bg-background-100 md:gap-4 md:p-4"
          >
            <div className="h-11 w-11 flex-shrink-0 overflow-hidden rounded-md border border-background-200 bg-background-100">
              <img
                src={site.logo}
                alt={`${site.name} 网站图标`}
                title={`${site.name} - 网址大全最新收录`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                  {site.name}
                </span>
                <span className="flex-shrink-0 rounded bg-accent-100 px-1.5 py-0.5 text-[10px] text-accent-900">
                  新收录
                </span>
              </div>
              <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500 md:hidden">{site.description}</p>
              <p className="mt-0.5 hidden text-xs text-foreground-500 md:line-clamp-1">{site.description}</p>
            </div>
            <div className="hidden flex-shrink-0 items-center gap-1 text-xs text-foreground-400 sm:flex">
              <i className="ri-calendar-line"></i>
              {formatDate(site.addedAt)}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}